import { JwtTokenFullData, getJwtTokenFullDataFromApiKey } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';

export interface IDecryptJWTParams {
  isEncrypted: boolean;
  jwt: string;
}

// Turns a JWT the backend couldn't convert into worker token data: an
// encrypted JWT is first decrypted by the wallet, then the backend proxies it
// to the worker. The main service's accounting gateway is the one that carries
// the user's auth token, so the conversion has to go through it.
export const decryptJWT = async ({
  isEncrypted,
  jwt,
}: IDecryptJWTParams): Promise<JwtTokenFullData> => {
  const web3Service = MultiService.getWeb3Service();

  const signedToken =
    isEncrypted && web3Service
      ? await web3Service.decryptInstantJwtToken(jwt)
      : jwt;

  try {
    const apiKey = await MultiService.getService()
      .getAccountingGateway()
      .convertJwtToApiKey({ jwt_token: signedToken });

    return (
      getJwtTokenFullDataFromApiKey({
        api_key: apiKey,
        jwt_data: signedToken,
      }) ?? {}
    );
  } catch (error) {
    throw new Error('Failed to import jwt token', { cause: error });
  }
};
